import { useState } from 'react';
import { TextField } from '@ui/field-text';
//import styles from './styles.module.sass';

export const MixNumberInput = ({ maxValue, onChange, ...rest }) => {
  const [currValue, setCurrValue] = useState(rest.value ?? 0);

  const getCurrentNumberValue = (
    currFieldValue: string | null,
    prevNumberValue: number,
  ) => {
    if (currFieldValue === null) {
      return 0;
    }

    if (RegExp(/\s/g).test(currFieldValue)) {
      return prevNumberValue;
    }

    if (
      !Number.isNaN(Number(currFieldValue)) &&
      Number.isFinite(Number(currFieldValue))
    ) {
      return Number(currFieldValue);
    }

    return prevNumberValue;
  };

  const onInputChange = (value: string | null) => {
    const newPrice = getCurrentNumberValue(value, currValue);

    if (newPrice !== currValue && newPrice <= maxValue) {
      setCurrValue(newPrice);
      onChange && onChange(newPrice);
    }
  };

  return (
    <TextField
      {...rest}
      onChange={({ value }) => onInputChange(value)}
      value={String(currValue)}
    />
  );
};
